import localUser from '@/utils/local-user'

class AjaxStorage {
  user: any = {}

  getUser() {
    if (this.user?.sid)
      return this.user

    const user = localUser.getQWUser() || {}
    this.user = user
    return this.user
  }
}

export default new AjaxStorage()
